export default __webpack_public_path__ + "static/media/guide_me.cfa671d6.webp";